// SEO Configuration
// Base URL sa www - OVO JE GLAVNA VERZIJA
export const BASE_URL = "https://www.predsense.ai";

export const DEFAULT_LANG = "en";
export const SUPPORTED_LANGS = ["en", "de"];
export const DEFAULT_OG_IMAGE = "/og-image.png";

export const OG_LOCALES = {
  en: "en_US",
  de: "de_DE",
};

// Helper funkcija za generisanje canonical URL-a
export const getCanonicalUrl = (path = "") => {
  // Ukloni početni slash ako postoji, pa dodaj ga ponovo
  const cleanPath = path.startsWith("/") ? path : `/${path}`;
  return `${BASE_URL}${cleanPath}`;
};

// Pretvara relativnu putanju (npr. /og-image.png) u apsolutni URL
export const getAbsoluteUrl = (pathOrUrl = "") =>
  /^https?:\/\//.test(pathOrUrl) ? pathOrUrl : getCanonicalUrl(pathOrUrl);

export const normalizeLang = (lang) =>
  lang && lang.startsWith("de") ? "de" : DEFAULT_LANG;

// "/de/blog/x" -> "de", "/blog/x" -> "en"
export const getLangFromPath = (pathname = "/") =>
  pathname === "/de" || pathname.startsWith("/de/") ? "de" : DEFAULT_LANG;

// "/de/blog/x" -> "/blog/x", "/de" -> "/"
export const stripLangPrefix = (pathname = "/") => {
  if (getLangFromPath(pathname) !== "de") return pathname || "/";
  const rest = pathname.slice(3);
  return rest === "" ? "/" : rest;
};

// ("/blog/x", "de") -> "/de/blog/x", ("/", "de") -> "/de"
// Hash i query string se zadržavaju.
export const localizePath = (path = "/", lang = DEFAULT_LANG) => {
  if (!path.startsWith("/")) return path;
  const match = path.match(/^([^?#]*)(.*)$/);
  const pathname = stripLangPrefix(match[1] || "/");
  const suffix = match[2] || "";
  if (normalizeLang(lang) !== "de") return `${pathname}${suffix}`;
  return `${pathname === "/" ? "/de" : `/de${pathname}`}${suffix}`;
};
